import { render, staticRenderFns } from "./userchats.vue?vue&type=template&id=6aa2acde&scoped=true"
import script from "./userchats.vue?vue&type=script&lang=js"
export * from "./userchats.vue?vue&type=script&lang=js"
import style0 from "./userchats.vue?vue&type=style&index=0&id=6aa2acde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2acde",
  null
  
)

export default component.exports